import { useState } from 'react';
import { login } from './cognito';

export function SignedOut() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const signIn = async () => {
    setBusy(true);
    setError(false);
    try { await login(); }
    catch { setError(true); setBusy(false); }
  };
  return (
    <main className="mx-auto max-w-lg px-6 py-16">
      <h1 className="text-2xl font-bold">You’re logged out</h1>
      <p className="my-4">Your saved assessments have not been deleted.</p>
      <p className="mb-6">Your organisation’s sign-in session may still be active. Signing in again may use the same account.</p>
      <button onClick={signIn} disabled={busy} className="rounded-md bg-green px-5 py-3 font-semibold text-code">{busy ? 'Signing in…' : 'Sign in'}</button>
      {error && <p role="alert" className="mt-4">Could not start sign-in. Please try again.</p>}
    </main>
  );
}
